import { ChartBarIcon } from "@heroicons/react/24/outline";
import { KanbanSquare, Route, ShieldCheck } from "lucide-react";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/coaching/dashboard",
    icon: ChartBarIcon,
    current: false,
    internalName: "coaching_dashboard",
  },
  {
    name: "Member Board",
    href: "/coaching/board",
    icon: KanbanSquare,
    current: false,
    internalName: "coaching_board",
  },
  {
    name: "Learning Paths",
    href: "/coaching/learning-paths",
    icon: Route,
    current: false,
    internalName: "learning_paths_dashboard",
  },
  {
    name: "Reviews",
    href: "/coaching/reviews",
    icon: ShieldCheck,
    current: false,
    internalName: "learning_path_reviews",
  },
];

/**
 * Not a rail app any more: these pages are reached through Coaches Progress Tracking
 * in the Learning Center. Kept so page titles and breadcrumbs for /coaching
 * routes still resolve (see utils/navigationHelpers).
 */
const coachingConfig = {
  sectionName: "coaching",
  defaultRoute: "/hub/learning-center/coaches-learning",
  navigation,
};

export default coachingConfig;
